import { useEffect, useMemo, useRef, useState } from "react"
import { SearchCompaniesOnMapContext } from "./SearchCompaniesOnMap.context"
import { useConfirmedCompanies } from "../../../../../hooks/fetchers/useConfirmedCompanies/useConfirmedCompanies";
import { useCurrentEntity } from "../../../../../hooks/fetchers/useCurrentEntity/useCurrentEntity";
import { useMergedStatesFromFetchers } from "../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers";
import { DashboardCompaniesFilters } from "../DashboardCompanies/DashboardCompanies.types";
import DashboardLayout from "../../../../commons/DashboardLayout/DashboardLayout";
import { MapRef } from "react-map-gl";
import { MapLocation } from "./SearchCompaniesOnMap.types";
import { AddressTypes } from "../../../../../types/models/address/address.types";
import CompaniesMapSearch from "./CompaniesMapSearch/CompaniesMapSearch";
import CompaniesMap from "./CompaniesMap/CompaniesMap";
import CompaniesDomainsFilterModal from "../DashboardCompanies/DashboardCompaniesTable/CompaniesDomainsFilterModal/CompaniesDomainsFilterModal";

export default () => {

  const mapRef = useRef<MapRef>(null)

  const [isDomainsFilterModalOpen, setDomainsFilterModalOpen] = useState(false);

  const [filters, setFilters] = useState<DashboardCompaniesFilters>({
    domains: [],
    fieldsOfActivity: [],
    region: undefined,
    department: undefined,
  });

  const [currentLocation, setCurrentLocation] = useState<MapLocation>();

  // const [currentDepartment, setCurrentDepartment] = useState<string>();
  // const [currentRegion, setCurrentRegion] = useState<string>();

  const [currentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(25);

  const { data: entity, isLoading: isEntityLoading } = useCurrentEntity();

  const {
    data: companies,
    // refetch: refetchCompanies,
    isLoading: isAllCompaniesLoading,
    isRefetching: isAllCompaniesRefetching,
  } = useConfirmedCompanies({
    page: currentPage,
    perPage: itemsPerPage,
    fieldsOfActivity: filters.domains.toString(),
    region: filters.region,
    department: filters.department,
  });

  const { isLoading } = useMergedStatesFromFetchers({
    loadings: [isEntityLoading, isAllCompaniesLoading, isAllCompaniesRefetching],
  });

  useEffect(() => {
    if (entity) {
      setFilters((value) => ({
        ...value,
        department: entity.department
      }))
      if (entity.latitude && entity.longitude) {
        mapRef.current?.setCenter([entity.longitude, entity.latitude])
        mapRef.current?.setZoom(13)
        setCurrentLocation({
          latitude: entity.latitude,
          longitude: entity.longitude,
          city: entity.city,
          department: entity.department,
          region: entity.region
        })
      }
    }
  }, [entity])

  useEffect(() => {
    console.log('filters', filters)
  }, [filters])

  useEffect(() => {
    if (currentLocation?.latitude && currentLocation.longitude) {
      mapRef.current?.setCenter([currentLocation.longitude, currentLocation.latitude])
    }
    switch (currentLocation?.type) {
      case AddressTypes.Address:
        mapRef.current?.setZoom(14)
        return
      case AddressTypes.City:
        mapRef.current?.setZoom(12.5)
        return
      case AddressTypes.Region:
        mapRef.current?.setZoom(8)
        return
    }
  }, [currentLocation])

  const contextValue = useMemo(
    () => ({
      companies,
      entity,
      isLoading,

      isDomainsFilterModalOpen,
      setDomainsFilterModalOpen,
      filters,
      setFilters,

      mapRef,

      currentLocation,
      setCurrentLocation
    }),
    [
      companies,
      entity,
      isLoading,

      isDomainsFilterModalOpen,
      setDomainsFilterModalOpen,
      filters,
      setFilters,

      mapRef,

      currentLocation,
      setCurrentLocation
    ]
  )

  return (
    <DashboardLayout style={{ padding: 0, maxHeight: '100vh' }}>
      <SearchCompaniesOnMapContext.Provider value={contextValue}>
        <div className="dashboard-companies flex-column">
          <CompaniesMapSearch />
          <CompaniesMap ref={mapRef} />
        </div>
        {isDomainsFilterModalOpen &&
          <CompaniesDomainsFilterModal
            isOpen={isDomainsFilterModalOpen}
            setOpen={setDomainsFilterModalOpen}
          />
        }
      </SearchCompaniesOnMapContext.Provider>
    </DashboardLayout>
  )
}